// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"089ec11c","160":"72a70d0c","208":"2be5db0e","293":"5e9a58b1","516":"230033bf","519":"d44e02dd","917":"8d27d58b","946":"dbdaf9f0"}[chunkId] + ".chunk.js";
};